import LazyComponent from './lazy-component';

export default LazyComponent;